import React from 'react';
import WithSideBarAndNavBar from '../../layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import { useNavigate } from 'react-router-dom';

const salarySpecification: React.FC = () => {
  const navigate = useNavigate();

  return (
    <WithSideBarAndNavBar>
      <div className="flex h-full flex-col items-center justify-center p-8">
        <div className="flex w-full max-w-[406px] flex-col gap-6">
          {/* 급여명세서 리뉴얼 카드 */}
          <div className="flex w-full flex-col items-center justify-center">
            <div
              className="flex h-[126px] w-full cursor-pointer items-center justify-between rounded-[12px] bg-[#43a199] px-6"
              onClick={() => {
                navigate(`/salary-entry?type=new`);
              }}>
              <div className="flex items-center">
                <p className="text-[25px] font-bold leading-6 text-white">급여명세서 리뉴얼</p>
              </div>
              <div className="flex h-[29px] w-[29px] items-center justify-center overflow-hidden">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="-rotate-90">
                  <path
                    d="M4 6L8 10L12 6"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* 업그레이드 안내 박스 */}
          <div className="flex w-full flex-col gap-6 rounded-[12px] py-[18px] pl-6">
            <p className="text-[20px] font-bold leading-6 text-[#333]">급여명세서가 업그레이드 됐어요!</p>

            <ul className="ml-4 flex w-full flex-col gap-6 text-base leading-6">
              <li className="list-disc text-[#333] marker:text-[#439f98]">
                <span className="font-bold text-[#439f98]">직원목록과 연동</span>
                <span className="text-[#333]">
                  되어 사업장에 합류한 직원은
                  <br />
                  급여대상자로 자동 생성되니 더 편리해졌어요
                </span>
              </li>
              <li className="list-disc text-[#333] marker:text-[#439f98]">
                <span className="font-bold text-[#439f98]">고정 항목 추가</span>
                <span className="text-[#333]">로 더 정밀한 급여 계산이 가능해요</span>
              </li>
              <li className="list-disc text-[#333] marker:text-[#439f98]">
                <span className="font-bold text-[#439f98]">산출식이 추가</span>
                <span className="text-[#333]">되어 정확한 급여 내역을 확인할 수 있어요</span>
              </li>
            </ul>

            <p className="text-base leading-6 text-[#333]">
              ※ 급여명세서 업데이트 상세내용은{' '}
              <span
                onClick={() => {
                  // navigate(`/salary-specification-upgrade-guide`);
                  window.open(
                    'https://wesopkr.notion.site/2d24fd14810f8059aeeefeccf406c2f0?source=copy_link',
                    '_blank',
                  );
                }}
                className="cursor-pointer font-bold text-[#252525] underline">
                여기
              </span>
              를 클릭해주세요.
            </p>

            <p className="text-base leading-6 text-[#333]">
              ※ 이전에 전송한 급여명세서가 안보인다면{' '}
              <span
                className="cursor-pointer font-bold text-[#252525] underline"
                onClick={() => {
                  navigate(`/salary-entry?type=old`);
                }}>
                구버전
              </span>
              을 클릭해주세요.
            </p>
          </div>
        </div>
      </div>
    </WithSideBarAndNavBar>
  );
};

export default salarySpecification;
